<div class="background-image"></div>
<div class="background-mask"></div>
<div class="pay-invoice-container">
  <div class="inner-container">
    <mat-card appearance="raised">
      <mat-progress-bar class="progress-loader"
        [mode]="loadingIndicator ? 'indeterminate' : 'determinate'" value="0"
      color="primary"></mat-progress-bar>
      <mat-card-content class="header-card">
        <div class="control-panel-container">
          <div class="control-panel-header">
            <h1>Pay Invoice!</h1>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    @if (!loadingIndicator) {
      <mat-card appearance="raised" class="invoice-container">
        <mat-card-content class="header-card">
          <div class="control-panel-container">
            <div class="control-panel-header">
              <h2>Invoice #{{invoice.invoiceNumber | invNumber}}</h2>
              <div class="line">
                <div class="description">Subtotal</div>
                <div class="value">{{$safeNavigationMigration(invoice.jobTotals?.subtotal) | currency}}</div>
              </div>
              <div class="line">
                <div class="description">Tax</div>
                <div class="value">{{$safeNavigationMigration(invoice.jobTotals?.tax) | currency}}</div>
              </div>
              <hr/>
              <div class="line">
                <div class="description">Grand Total</div>
                <div class="value">{{$safeNavigationMigration(invoice.jobTotals?.totalWithTax) | currency}}</div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }

    @if (!loadingIndicator) {
      <mat-card appearance="raised" class="invoice-container">
        <mat-card-content class="header-card">
          <div class="control-panel-container">
            <div class="control-panel-header">
              <h2>Billing Address</h2>
              <div class="line less-margin">
                <div class="description">{{getBillingAddress()?.line1}}</div>
              </div>
              @if (getBillingAddress()?.line2) {
                <div class="line less-margin">
                  <div class="description">{{getBillingAddress()?.line2}}</div>
                </div>
              }
              @if (getBillingAddress()?.suburb) {
                <div class="line less-margin">
                  <div class="description">{{getBillingAddress()?.suburb}}</div>
                </div>
              }
              <div class="line less-margin">
                <div class="description">{{getBillingAddress()?.city}}</div>
              </div>
              <div class="line less-margin">
                <div class="description">{{getBillingAddress()?.state}}</div>
              </div>
              <div class="line less-margin">
                <div class="description">{{getBillingAddress()?.country}}</div>
              </div>
              <div class="line less-margin">
                <div class="description">{{getBillingAddress()?.postalCode}}</div>
              </div>
              <i style="font-size:11px;">If your billing address is wrong please contact me.</i>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }

    @if (!loadingIndicator) {
      <app-payment-gateway
        [billingAddress]="getBillingAddress()"
        [paymentProviderConfig]="testProviderConfig"
        [organizationHandle]="organizationHandle"
        [organizationId]="organizationId"
        [jobId]="id"
      ></app-payment-gateway>
    }
  </div>
</div>

